export default function initSmoothScroll() {
  // CSS `scroll-behavior: smooth` covers most cases.
  // This adds reliable smooth scrolling for hash links and respects reduced motion.
  const prefersReduce = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

  document.addEventListener("click", (e) => {
    const a = e.target?.closest?.('a[href^="#"]');
    if (!a) return;

    const href = a.getAttribute("href") || "";
    const hash = href.startsWith("#") ? href : "";
    if (!hash || hash === "#") return;

    const id = decodeURIComponent(hash.slice(1));
    const target = document.getElementById(id) || document.querySelector(`[name="${CSS.escape(id)}"]`);
    if (!target) return;

    e.preventDefault();

    target.scrollIntoView({ behavior: prefersReduce ? "auto" : "smooth", block: "start" });

    // Update URL without jump
    if (history.pushState) {
      history.pushState(null, "", hash);
    } else {
      window.location.hash = hash;
    }
  });
}
